import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { isMobile } from 'react-device-detect';
import { Link, useLocation } from 'react-router-dom';
import styles from './Header.module.css';

function Header(props) {
  const location = useLocation();
  const isDpgRoute = location.pathname.startsWith('/dpg');

  return (
    <header className={`${styles.header} ${isMobile && styles.mobile}`}>
      <div className={styles.headerContent}>
        <Link
          to={isDpgRoute ? '/dpg/stepOne/introduction/' : '/home/stepOne/introduction/'}
          onClick={() => {
            sessionStorage.clear();
            sessionStorage.setItem('sessionId', uuidv4());
          }}
        >
          <img src={isMobile ? '/logos/icon-filled.png' : '/logos/Adways-Logo.png'} alt="Adways logo" className={styles.logo} />
        </Link>

        {isDpgRoute && !isMobile && <img src="/logos/DPG Media Logo White.svg" alt="DPG Media logo" className={styles.dpgLogo} />}
      </div>
      {isMobile && <h1 className={styles.ezRichMediaheader}>Easy Rich Media</h1>}
    </header>
  );
}

export default Header;
